import React from 'react';

export default function CustomKeypad({ onPress, onBackspace, onEnter, style }) {
  const buttonSize = 72;        // 정사각형 버튼 크기
  const buttonGap = 8;          // gap-between
  const totalRows = 4;

  const keypadHeight = buttonSize * totalRows + buttonGap * (totalRows - 1);

  return (
    <div
      className="card p-2 shadow d-flex flex-row"
      style={{
        position: 'absolute',
        top: '50px',
        left: '0px',
        zIndex: 1000,
        ...style,
      }}
    >
      {/* 숫자 키패드 영역 */}
      <div
        className="d-flex flex-wrap"
        style={{
          width: buttonSize * 3 + buttonGap * 2,
          gap: `${buttonGap}px`,
        }}
      >
        {['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '00'].map((num) => (
          <button
            key={num}
            className="btn btn-outline-primary"
            onClick={() => onPress(num)}
            style={{
              width: `${buttonSize}px`,
              height: `${buttonSize}px`,
              fontSize: '1.5rem',
              padding: 0,
            }}
          >
            {num}
          </button>
        ))}
        <button
          className="btn btn-danger"
          onClick={onBackspace}
          style={{
            width: `${buttonSize}px`,
            height: `${buttonSize}px`,
            fontSize: '1.5rem',
            padding: 0,
          }}
        >
          ←
        </button>
      </div>

      {/* 입력 버튼 영역 */}
      <div
        className="d-flex align-items-start"
        style={{ marginLeft: `${buttonGap}px`, padding: 0 }}
      >
        <button
          className="btn btn-success"
          onClick={onEnter}
          style={{
            width: `${buttonSize}px`,
            height: `${keypadHeight}px`,
            fontSize: '1.5rem',
            writingMode: 'vertical-rl',
            textOrientation: 'mixed',
            padding: 0,
          }}
        >
          입력
        </button>
      </div>
    </div>
  );
}
